<template>
	<div>
		<div class="flex justify-end">
			<div class="font-normal mb-4 rounded overflow-hidden">
				<BaseButton :class="{ 'btn-blue': showBrutto }" class="p-1 w-20 text-sm min-w-0 rounded-none" @click="showBrutto = true">{{
					$t('gross')
				}}</BaseButton>
				<BaseButton :class="{ 'btn-blue': !showBrutto }" class="p-1 w-20 text-sm min-w-0 rounded-none" @click="showBrutto = false">{{
					$t('net')
				}}</BaseButton>
			</div>
		</div>
		<div v-for="companyVariable in getVisibleCompanyVariables" :key="companyVariable.id" class="flex justify-between pb-4">
			<div class="w-3/4 text-left">{{ companyVariable.label }}</div>
			<div class="font-bold">{{ getValue(companyVariable) }}</div>
		</div>
	</div>
</template>

<script>
import Formatter from '@/mixins/Formatter';
import BaseButton from '@/components/forms/buttons/BaseButton';

export default {
	name: 'CompanyVariablesList',
	components: { BaseButton },
	mixins: [Formatter],
	props: {
		companyVariables: { required: true },
	},
	data() {
		return {
			showBrutto: false,
		};
	},
	computed: {
		getVisibleCompanyVariables() {
			const hidden = ['lackmaterial', 'verbringungskosten'];
			return this.companyVariables.filter(companyVariables => !hidden.includes(companyVariables.key));
		},
	},
	methods: {
		getCompanyVariableByKey(key) {
			return this.companyVariables.find(companyVariables => companyVariables.key === key);
		},
		isPercent(companyVariable) {
			const key = companyVariable.key;
			const isUPEAufschlag = key === 'upeaufschlag_auf_ersatzteile';

			if (key === 'lackmaterial_wert') {
				const lackmaterial = this.getCompanyVariableByKey('lackmaterial');
				companyVariable.label = lackmaterial.label;
				return lackmaterial.value === 'percent';
			}

			return isUPEAufschlag;
		},
		isHour(companyVariable) {
			const key = companyVariable.key;

			if (key === 'verbringungskosten_wert') {
				const verbringungskosten = this.getCompanyVariableByKey('verbringungskosten');
				companyVariable.label = verbringungskosten.label;
				return verbringungskosten.value === 'hours';
			}

			return false;
		},
		isInclusive(companyVariable) {
			const key = companyVariable.key;

			if (key === 'lackmaterial_wert') {
				const lackmaterial = this.getCompanyVariableByKey('lackmaterial');
				companyVariable.label = lackmaterial.label;
				return lackmaterial.value === 'includes';
			}

			if (key === 'verbringungskosten_wert') {
				const verbringungskosten = this.getCompanyVariableByKey('verbringungskosten');
				companyVariable.label = verbringungskosten.label;
				return verbringungskosten.value === 'includes';
			}

			return false;
		},
		isWithoutCurrency(companyVariable) {
			const key = companyVariable.key;

			if (key === 'lackmaterial_wert') {
				const lackmaterial = this.getCompanyVariableByKey('lackmaterial');
				return lackmaterial.value === 'misc';
			}

			return false;
		},
		getValue(companyVariable) {
			const isInclusive = this.isInclusive(companyVariable);

			if (!companyVariable.value && !isInclusive) return '-';

			if (this.isPercent(companyVariable)) {
				return companyVariable.value + ' %';
			} else if (this.isHour(companyVariable)) {
				return companyVariable.value / 10 + ' Std.';
			} else if (this.isWithoutCurrency(companyVariable)) {
				return companyVariable.value;
			} else if (isInclusive) {
				return 'Inklusive';
			} else {
				const value = !this.showBrutto ? companyVariable.value : companyVariable.value_brutto;
				return this.formatMoney(value);
			}
		},
	},
};
</script>

<style scoped></style>
